import type {IProfile} from '../pages/Profile/types';

export const VERIFICATION_REQUIRED_EVENT = 'tyrebase:verification-required';
export const VERIFICATION_COMPLETED_EVENT = 'tyrebase:verification-completed';

/** У старых аккаунтов дата подтверждения могла сохраниться без адреса почты. */
export const hasVerifiedEmail = (profile?: IProfile): boolean => Boolean(
    profile?.email?.trim() && profile.email_verified_at
    && !profile.email_required && !profile.email_verification_required
);

/** Передаёт отказ API корневому guard без перезагрузки и потери сессии. */
export const notifyVerificationRequired = (status: unknown, data: unknown): boolean => {
    if (status !== 403 || (data as {code?: string})?.code !== 'email_verification_required') return false;
    window.dispatchEvent(new Event(VERIFICATION_REQUIRED_EVENT));
    return true;
};

/** Возвращает первое сообщение API для компактной ошибки под полем. */
export const verificationError = (error: unknown, fallback: string): string => {
    const data = (error as {response?: {data?: {message?: string; errors?: Record<string, string[]>}}})?.response?.data;
    return Object.values(data?.errors ?? {}).flat()[0] || data?.message || fallback;
};
